import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20backstage%20corridor%20with%20glowing%20spotlights%20and%20warm%20haze%2C%20empty%20film%20set%20atmosphere%2C%20abstract%20cinematic%20editorial%20photography%2C%20deep%20coral%20red%20and%20cream%20tones%2C%20no%20people%2C%20high%20detail&width=1600&height=900&seq=gt-hero-main&orientation=landscape"
          alt="暖调聚光灯下的后台通道，营造圈内秘闻氛围"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/60 to-foreground-950/80"></div>

      <div className="relative mx-auto flex min-h-[520px] w-full max-w-[1280px] flex-col items-center justify-center px-4 py-20 text-center md:px-6 md:py-28">
        <p className="mb-5 inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-xs text-background-100 backdrop-blur">
          <i className="ri-water-flash-line text-accent-300"></i> 圈内八卦内幕聚集地 · 每日放送
        </p>
        <h1 className="max-w-3xl font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
          每天都有新瓜，
          <br className="hidden sm:block" />
          瓜田秘闻社陪你慢慢扒
        </h1>
        <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
          {siteInfo.description}
        </p>
        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <Link
            to="/news"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-restart-line"></i> 开始吃瓜
          </Link>
          <Link
            to="/topics"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/10 px-6 py-3 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
          >
            <i className="ri-bookmark-3-line"></i> 看专题深扒
          </Link>
        </div>

        <dl className="mt-14 grid w-full max-w-3xl grid-cols-2 gap-6 border-t border-background-50/20 pt-8 md:grid-cols-4">
          {siteInfo.stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <dt className="text-xs text-background-100/70">{stat.label}</dt>
              <dd className="mt-1 font-heading text-xl font-bold text-accent-300 md:text-2xl">
                {stat.value}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}